import { AnimatedBanner } from "@faire/retailer-visitor-shared/components/AnimatedBanner/AnimatedBanner";
import { ImpBanner } from "@faire/retailer-visitor-shared/components/Notifications/Components/Conductor/ImpBanner";
import { useGetBannerContentByViewport } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/useGetBannerContentByViewport";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";
import React from "react";

interface IProps {
  banners: IProductMessageByViewport[];
}

export const ImpAnimatedBanner: React.FC<IProps> = ({ banners }) => {
  const { bannerContents, bannerNames } =
    useGetBannerContentByViewport(banners);

  return (
    <AnimatedBanner
      banners={bannerContents.map((banner, i) => (
        <ImpBanner key={i} message={banner} />
      ))}
      faireValuesBannerNames={bannerNames}
    />
  );
};
